import { createRouter, createWebHistory } from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';

import { appRoutes } from './routes';
import { REDIRECT_MAIN, NOT_FOUND_ROUTE } from './routes/base';
import createRouteGuard from './guard';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

function isChunkLoadError(err: unknown) {
  const message =
    err instanceof Error
      ? err.message
      : typeof err === 'string'
        ? err
        : '';

  // Vite: "Failed to fetch dynamically imported module"
  // Webpack: "Loading chunk XXX failed" / "ChunkLoadError"
  return /Loading chunk \d+ failed|ChunkLoadError|CSS_CHUNK_LOAD_FAILED|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
    message
  );
}

function hardReloadOnce() {
  const key = 'router:chunk-load-reload-at';
  const last = Number(sessionStorage.getItem(key) ?? 0);
  const now = Date.now();

  // avoid infinite reload loops if server keeps returning 404
  if (now - last < 10_000) return;
  sessionStorage.setItem(key, String(now));

  const url = new URL(window.location.href);
  url.searchParams.set('__reload', String(now));
  window.location.replace(url.toString());
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: 'login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    ...appRoutes,
    REDIRECT_MAIN,
    NOT_FOUND_ROUTE,
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

createRouteGuard(router);

router.onError((err) => {
  if (isChunkLoadError(err)) {
    hardReloadOnce();
  }
});

export default router;
